<template>
    <edit-view-base :filter="filter" :has-card-view="false" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Country', apiMethod: 'Countries', form: () => import('../forms/CountryForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                ],
                tabs: [
                    { text: 'Addresses', value: 'countryId', table: () => import('../tables/AddressesTable') },
                ],
                mainForm: () => import('../forms/CountryForm'),
                claimName: 'Countries',
                apiMethod: 'Countries',
            }
        }
    };
</script>
